import transferServices from '@/api/transferServices';
import { RootState } from '@/app/store';
import { SwiftTransfer } from '@/interfaces/transfer';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

interface InternalState {
  swiftTransfers: SwiftTransfer[];
  totalElements: number;
  totalPages: number;
  recordsSize: number;
  number: number;
  loading: boolean;
  error: string;
  selectedPicture: { [key: string]: string };
  pictureLoading: boolean;
}

const initialState: InternalState = {
  swiftTransfers: [],
  totalElements: 0,
  totalPages: 0,
  recordsSize: 0,
  number: 0,
  loading: false,
  error: '',
  selectedPicture: {},
  pictureLoading: false,
};

export const fetchSwiftTransfers = createAsyncThunk('swiftTransfers/fetch', async (params: any) => {
  return transferServices.loadSwiftTransfers(params);
});

export const fetchImage = createAsyncThunk('swiftTransfers/fetchImage', async ({ id, fileName }: { id: string; fileName: string }, thunkAPI) => {
  try {
    const result = await transferServices.fetchSwiftFile(id, { fileName });
    return result;
  } catch (error: any) {
    let responseObj = await error;
    const errorMessage = responseObj.message;
    return thunkAPI.rejectWithValue(errorMessage);
  }
});

export const swiftTransfersSlice = createSlice({
  name: 'swiftTransfers',
  initialState,
  reducers: {
    clearSwiftTransfers: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchSwiftTransfers.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchSwiftTransfers.fulfilled, (state, action) => {
      const {
        payload: { data, size, totalElements, totalPages, number },
      } = action;
      state.swiftTransfers = data;
      state.recordsSize = size;
      state.totalElements = totalElements;
      state.totalPages = totalPages;
      state.number = number + 1;
      state.loading = false;
    });

    builder.addCase(fetchSwiftTransfers.rejected, state => {
      state.loading = false;
      state.error = 'Error';
    });

    builder.addCase(fetchImage.pending, state => {
      state.pictureLoading = true;
    });

    builder.addCase(fetchImage.fulfilled, (state, action) => {
      const {
        payload,
        meta: {
          arg: { id, fileName },
        },
      } = action;
      state.selectedPicture[`${id}-${fileName}`] = payload;
      state.pictureLoading = false;
    });

    builder.addCase(fetchImage.rejected, state => {
      state.pictureLoading = false;
      state.error = 'Error';
    });
  },
});

export const selectSwiftTransfers = (state: RootState) => state.swiftTransfer;
export const { clearSwiftTransfers } = swiftTransfersSlice.actions;
export default swiftTransfersSlice.reducer;
